import { assetFolders } from 'common/constants'
import { GuestTheme } from 'core/skins/GUEST/theme'
import { IndependentTheme } from 'core/skins/INDEPENDENT/theme'
import { InfinitiTheme } from 'core/skins/INFINITI/theme'
import { NissanCustomStyle } from 'core/skins/NISSAN/custom'
import { theme } from 'core/skins/NISSAN/theme'
import { PropsWithChildren } from 'react'
import { useGlobalStore } from 'store/useGlobalStore'
import { ThemeProvider, createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
`

export const PortalThemeProvider = ({ children }: PropsWithChildren<any>) => {
  const [assetFolder] = useGlobalStore((state) => [state.userClaims.CurrentBuyerTypeAssetFolder])

  const getTheme = () => {
    switch (assetFolder) {
      case assetFolders.Infiniti:
        return InfinitiTheme
      case assetFolders.Nissan:
        return theme
      case assetFolders.Independent:
        return IndependentTheme
      default:
        return GuestTheme
    }
  }
  return (
    <ThemeProvider theme={getTheme()}>
      <GlobalStyle />
      <NissanCustomStyle>{children}</NissanCustomStyle>
    </ThemeProvider>
  )
}
